<div>
  <div class="history-item flex flex-row justify-start items-start">
    <div class="flex-[20%] max-w-[20%]">{{ message?.count }}</div>
    <div class="flex-[50%] max-w-[50%]">{{ createdTimestamp | date: 'short' }}</div>
    <div class="flex-[30%] max-w-[30%]">{{ message?.error_code }}</div>
    <!-- TODO - VIG-2257 commented temporarily -->
    <!-- <div class="gap-[8px] justify-start items-start" class="flex flex-col flex-[35%] max-w-[35%]">
      <div>
        <ng-container *ngIf="activeErrorDetailsState$ | async as details; else noData">
          <div
            *ngIf="details?.loading; else showData"
            class="flex flex-row gap-[8px] justify-start items-center"
          >
            <vi-loader [isLoading]="true"></vi-loader>
          </div>
          <ng-template #showData>
            <ng-container
              *ngIf="(details?.faultCodes)[0]?.systemCharacteristics; else noDescription"
            >
              <div [innerHTML]="(details?.faultCodes)[0]?.systemCharacteristics"></div>
            </ng-container>
            <ng-template #noDescription>
              <div>{{ noValue }}</div>
            </ng-template>
          </ng-template>
        </ng-container>
        <ng-template #noData>
          <div>{{ noValue }}</div>
        </ng-template>
      </div>
      <div
        class="show-more-label flex flex-row justify-start items-center"
        (click)="expand()"
        data-at-refrigerant-circuit-history-expand
        gtm="onClose"
        gtmAction="Refrigerant circuit history Modal"
        gtmCategory="refrigerantCircuitHistory"
      >
        <ng-container *ngIf="!isExpanded; else expanded">
          <span>{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT_HISTORY_MODAL.ERROR.READ_MORE'
              | translate
          }}</span>
          <mat-icon>keyboard_arrow_down</mat-icon>
        </ng-container>
        <ng-template #expanded>
          <span>{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT_HISTORY_MODAL.ERROR.CLOSE' | translate
          }}</span>
          <mat-icon>keyboard_arrow_up</mat-icon>
        </ng-template>
      </div>
    </div> -->
  </div>
  <!-- TODO - VIG-2257 commented temporarily -->
  <!-- <div *ngIf="isExpanded">
    <app-refrigerant-circuit-history-details
      [errorDetails]="(activeErrorDetailsState$ | async)?.faultCodes"
    ></app-refrigerant-circuit-history-details>
  </div> -->
</div>
